// extracted by mini-css-extract-plugin
export default {"dxgScoringSummary":"DxgScoringSummary_dxgScoringSummary__A-SFk"};